import { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';

import { QUALITY_DESCRIPTIONS } from 'legacy/appstore/constants';

import { isFunc } from 'legacy/utils/utils';

import { ConditionSelector as theme } from 'legacy/css-modules';

// Used for calculating width of the tooltip
const PAGE_PADDING = 105;
const PAGE_MAX_WIDTH = 1250;
const CARET_HEIGHT = 8;

class ConditionSelectorButton extends Component {
  state = {
    hovered: false
  };

  handleMouseEnter = () => {
    const { value, onMouseEnter } = this.props;
    onMouseEnter(value);
    this.setState({
      hovered: true
    });
  };

  handleMouseLeave = () => {
    this.setState({
      hovered: false
    });
  };

  calcBorderWidth = () => {
    const { active, node } = this.props;
    const { hovered } = this.state;
    let borderWidth;
    let borderHeight = hovered || active ? CARET_HEIGHT : 0;
    if (!node) {
      borderWidth = 0;
    } else {
      const { width } = node.getBoundingClientRect();
      borderWidth = width / 2;
    }
    return {
      borderWidth: `${borderHeight}px ${borderWidth}px 0px ${borderWidth}px`
    };
  };

  render() {
    const { value, label, active, onClick } = this.props;
    return (
      <div
        data-hc-name="condition-selector-button"
        onClick={() => onClick(value)}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        className={classNames(theme.SelectorButtonWrapper, {
          [theme.active]: active
        })}
      >
        <div className={theme.SelectorButton}>
          <div className={theme.Caret} style={this.calcBorderWidth()} />
        </div>
        <div className={theme.SelectorButtonLabel}>{label}</div>
      </div>
    );
  }
}

const ConditionExplanation = ({ description, source, width }) => {
  if (!description) return null;
  return (
    <div
      className={theme.ConditionExplanation}
      style={{ width: `${width}px` }}
      data-hc-name="condition-selector-tooltip"
    >
      {description}
      {source && <div className={theme.Source}>Source: {source}</div>}
    </div>
  );
};

class ConditionSelector extends Component {
  static defaultProps = {
    showTooltip: true
  };

  state = {
    hovered: null,
    explanationWidth: null,
    width: 0
  };

  node;
  buttons = {};

  componentDidMount() {
    this.updateWindowSize();
    window.addEventListener('resize', this.resizeWindow);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeWindow);
  }

  resizeWindow = () => {
    window.requestAnimationFrame(() => {
      this.updateWindowSize();
    });
  };

  updateWindowSize = () => {
    if (this.node && isFunc(this.node.getBoundingClientRect)) {
      this.setState({
        width: this.node.getBoundingClientRect().width
      });
    }
  };

  handleMouseEnter = (value) => {
    const contentWidth = Math.min(PAGE_MAX_WIDTH, window.innerWidth);
    const nodeWidth = this.node.getBoundingClientRect().width;
    this.setState({
      hovered: value,
      explanationWidth: contentWidth - PAGE_PADDING - nodeWidth
    });
  };

  handleMouseLeave = (value) => {
    this.setState({
      hovered: null
    });
  };

  render() {
    const { hovered, explanationWidth, width } = this.state;
    const { condition, options, showTooltip, onChange, disabled } = this.props;
    return (
      <div
        ref={(node) => {
          this.node = findDOMNode(node);
        }}
        className={theme.ConditionSelector}
        onMouseLeave={this.handleMouseLeave}
        data-hc-name="condition-selector"
      >
        {options.map(({ value, label, helpText }, i) => {
          return (
            <ConditionSelectorButton
              key={`condition-selector--${value}`}
              value={value}
              label={label}
              ref={(node) => {
                this.buttons[value] = findDOMNode(node);
              }}
              node={this.buttons[value]}
              active={value === condition}
              onClick={(v) => {
                if (!disabled) {
                  onChange(v);
                }
              }}
              onMouseEnter={this.handleMouseEnter}
              resizeTrigger={width}
            />
          );
        })}
        {hovered && showTooltip && (
          <ConditionExplanation
            {...QUALITY_DESCRIPTIONS[hovered]}
            width={explanationWidth}
          />
        )}
      </div>
    );
  }
}

export default ConditionSelector;
